import { render, staticRenderFns } from "./DisplayReviewFile.vue?vue&type=template&id=67c440a6&"
import script from "./DisplayReviewFile.vue?vue&type=script&lang=js&"
export * from "./DisplayReviewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports